export enum AppRoutes {
  ROOT = "/",
  ORGANIZATION = "/:organization",
  DONATE = "/:organization/donate",
  DONATE_NGOS = "/:organization/donate/ngos",
  DONATE_SUMMARY = "/:organization/donate/summary",

  ORG_BASE = "/*",
  ORG_LOGIN = "/login",
  ORG_FORGOT_PASSWORD = "/organization/forgot-password",


  DONATION = "/donate",
  DONOR_LOGIN = "/login/donor",
  DONOR_REGISTER = "/register/donor",
}

export enum Routes {
  // Superadmin 
  ADMIN_DASHBOARD = "dashboard",
  ADMIN_ORGANIZATIONS = "organizations",
  ADMIN_ORGANIZATIONS_ADD = "organizations/add",
  ADMIN_ORGANIZATIONS_UPDATE = "organizations/update/:organizationId",
  ADMIN_CITY_LIST = "cities",
  ADMIN_NGO_LIST = "ngos",
  ADMIN_NGO_ADD = "ngo/add",
  ADMIN_NGO_EDIT = "ngo/edit/:ngoId",
  ADMIN_CAMPAIGN_LIST = "campaign",
  ADMIN_CAMPAIGN_ADD = "campaign/add",
  ADMIN_CAMPAIGN_EDIT = "campaign/edit/:campaignId",
  ADMIN_CATEGORY = "categories",

  // Org Admin 
  ORG_DASHBOARD = "dashboard",
  ORG_CITIES = "cities",
  ORG_NGOS = "ngos",
  ORG_REPORT = "report",
  ORG_SETTINGS = "settings",
  USER_SETTINGS = "user-settings",
  ORG_NGO_ADD = "ngo/add",
  ORG_NGO_EDIT = "ngo/edit/:ngoId",
  ORG_CAMPAIGN = "campaign",
  ORG_CAMPAIGN_ADD = "/campaign/add",
  ORG_CAMPAIGN_EDIT = "/campaign/edit/:campaignId",
  ORG_PROJECT = "projects",
  DONATIONS = "donations",
  ADD_DONATIONS = "donations/add",
  EDIT_DONATION = "/donations/edit/:donorId",
  MEMBERS = "members",
  ADD_MEMBERS = "members/add/:organizationId",
  EDIT_MEMBERS = "members/edit/:memberId",
  MY_DONATION = "/my-donation",
  ORG_MEMBER = "/organization-member",

  //common
  RESET_PASSWORD = "/reset-password"
}